export default {
	registerPercentage: 1, // 叠加计算均分的进度条值
	registerStep:       { uploadObject: {}, inputInfo: {}, setPassword: {} }, //注册流程数据
	tabsActive:         0, //服务页tabs高亮
};
